/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { FormDefinitionDto } from '../models/form-definition-dto';
import { formDefinitionGet } from '../fn/form-definition/form-definition-get';
import { FormDefinitionGet$Params } from '../fn/form-definition/form-definition-get';

@Injectable({ providedIn: 'root' })
export class FormDefinitionHttpService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formDefinitionGet()` */
  static readonly FormDefinitionGetPath = '/FormDefinition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formDefinitionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  formDefinitionGet$Response(
    params?: FormDefinitionGet$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<FormDefinitionDto>> {
    const obs = formDefinitionGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formDefinitionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formDefinitionGet(params?: FormDefinitionGet$Params, context?: HttpContext): Observable<FormDefinitionDto> {
    const resp = this.formDefinitionGet$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<FormDefinitionDto>): FormDefinitionDto => r.body));
  }
}
